import { render, staticRenderFns } from "./LinhaDataTableExpandida.vue?vue&type=template&id=b34cac12&scoped=true"
import script from "./LinhaDataTableExpandida.vue?vue&type=script&lang=js"
export * from "./LinhaDataTableExpandida.vue?vue&type=script&lang=js"
import style0 from "./LinhaDataTableExpandida.vue?vue&type=style&index=0&id=b34cac12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34cac12",
  null
  
)

export default component.exports